import Select from 'react-select';

interface SearchSelectProps {
  options: Array<object>;
  value: string;
  name: string;
  isDisabled?: boolean;
  menuPortalTarget?: HTMLElement;
  onChange?: (val: any) => void;
}

const SearchSelect = ({
  options,
  value,
  name,
  onChange,
}: SearchSelectProps) => {
  return (
    <div id="search-select">
      <Select
        options={options}
        value={
          options.length > 0
            ? options.find(
                (option: any) =>
                  option.value?.toLowerCase() === value?.toLowerCase(),
              )
            : ''
        }
        classNamePrefix="select"
        className="react-select"
        onChange={onChange}
        name={name}
        menuPosition="fixed"
        components={{
          IndicatorSeparator: () => null,
        }}
      />
    </div>
  );
};

export default SearchSelect;

SearchSelect.defaultProps = {
  isDisabled: false,
};
